import PortalClienteService from "services/bases/PortalClienteService";

class ContatosService extends PortalClienteService{
    async ListarPorDireito(direitoid){
        return await this.get(`contatos/ListarContatosPorDireito?direitoId=${direitoid}`)
    }
    async ObterContato(contatoid, statusPerfilAcesso = null, statusDireito = null){ 

        const params = new URLSearchParams();

        params.append('contatoId', contatoid);

        if (statusPerfilAcesso != null) {
            params.append('statusPerfilAcesso', statusPerfilAcesso);
        }
        if (statusDireito != null) {
            params.append('statusDireito', statusDireito);
        }

        return await this.get(`contatos/ObterContato?${params.toString()}`)
    }
}

export default new ContatosService();